import { useNavigate } from 'react-router-dom';

export default function CtaSection() {
  const navigate = useNavigate();

  return (
    <section
      className="relative py-28 overflow-hidden"
      style={{
        backgroundImage: `url('https://readdy.ai/api/search-image?query=beautiful%20freshly%20painted%20Wellington%20New%20Zealand%20home%20exterior%20stunning%20transformation%20professional%20painting%20result%20curb%20appeal%20sunny%20day%20lush%20garden%20premium%20quality%20finish%20residential%20property&width=1440&height=600&seq=cta2001&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-[#1C1C1C]/88" />
      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-10 text-center">
        <span className="inline-block text-gray-400 text-sm font-semibold tracking-widest uppercase mb-4">Get Started Today</span>
        <h2 className="text-4xl md:text-6xl font-black text-white mb-6 tracking-tight leading-tight">
          Ready to transform<br />your home?
        </h2>
        <p className="text-white/65 text-lg mb-10 max-w-xl mx-auto">
          Get a free, no-obligation quote from Wellington's trusted painting and decorating experts.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="/contact"
            onClick={(e) => { e.preventDefault(); navigate('/contact'); }}
            className="px-10 py-4 bg-white text-[#1C1C1C] font-bold rounded-full whitespace-nowrap hover:bg-gray-100 transition-all cursor-pointer text-base"
          >
            Get a Free Quote
          </a>
          <a
            href="tel:0223760868"
            className="px-10 py-4 border-2 border-white/40 text-white font-bold rounded-full whitespace-nowrap hover:border-white hover:bg-white/10 transition-all cursor-pointer text-base flex items-center gap-2 justify-center"
          >
            <i className="ri-phone-line" /> Call Now
          </a>
        </div>
      </div>
    </section>
  );
}
